import VehicleBlockShellCapInfernal from "./VehicleBlockShellCapInfernal";

export default VehicleBlockShellCapInfernal;
export { VehicleBlockShellCapInfernal };
